/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { getLogoTitle } from '../../helpers/serviceDeskHelpers';
import { AMAZON_CONNECT_BYOSD_TYPE } from '../../util/channelTypes';

import './AmazonConnect.scss';

interface AmazonConnectIconMinimalProps {
  className?: string;
  size?: number;
}

export const AmazonConnectIconMinimal = ({
  className,
  size = 32,
  ...others
}: AmazonConnectIconMinimalProps) => {
  const intl = useIntl();
  const pxSize = size + 'px';
  return (
    <svg
      className={cx('AmazonConnectIconMinimal', className)}
      height={pxSize}
      id="AmazonConnect_minimal_Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 175 158.76"
      {...others}>
      <title id="amazon-Connect-title">
        {getLogoTitle(AMAZON_CONNECT_BYOSD_TYPE, intl)}
      </title>
      <path
        className="amazon__a"
        d="M240,125.16a79.09,79.09,0,0,0-73-48.37h-.16a79.76,79.76,0,0,0-41,11.8c-12,7.27-22,17.48-28.18,28.76a2,2,0,1,0,3.46,1.9C106.9,108.57,116.4,98.88,127.82,92a75.79,75.79,0,0,1,39-11.23H167a75.43,75.43,0,1,1-38.11,140.62,75.9,75.9,0,0,1-27.05-26.91,2,2,0,0,0-3.4,2,79.33,79.33,0,0,0,68.4,39.08A79.5,79.5,0,0,0,240,125.16M82.25,133.7h24.94a2,2,0,0,0,0-3.95H82.25a2,2,0,0,0,0,3.95m16.46,23.62a2,2,0,0,0-2-2H75a2,2,0,1,0,0,3.95H96.74a2,2,0,0,0,2-2m8.4,25.59a2,2,0,0,0-2-2H78.46a2,2,0,0,0,0,3.95h26.67a2,2,0,0,0,2-2m17.6-41.42a2,2,0,0,0,1.63-2.27c-1.46-8.84,0-16.7,4.28-22.74A27,27,0,0,1,147,105.9c13.44-3,29.61,3.1,34.5,20.51a2,2,0,0,0,1.07,1.26,2,2,0,0,0,1.66,0c5.45-2.52,11-2.7,15.65-.5s8.16,6.69,9.67,12.53a2,2,0,0,0,1.56,1.45C224,143.48,229.4,153.32,229.06,162a19.46,19.46,0,0,1-5,12.35,21.35,21.35,0,0,1-13.86,6.55H188.48a2,2,0,0,0-1.35.53L154,212.3V182.67a2,2,0,0,0-2-2H125.47a19,19,0,0,1-13.12-6.27,20.36,20.36,0,0,1-5-12.59A19.57,19.57,0,0,1,111.26,149c3-4,7.7-6.59,13.45-7.53M103.43,162c.45,10.17,7.48,21.58,21.82,22.63h24.82v32.2a2,2,0,0,0,1.18,1.81,2,2,0,0,0,2.14-.36l35.87-33.4h21.25c15-1.51,22.1-12.48,22.5-22.69a23.88,23.88,0,0,0-5-15.6,25.65,25.65,0,0,0-15-9.08c-2-6.41-6-11.32-11.47-13.91a21.56,21.56,0,0,0-16.93-.37,31.65,31.65,0,0,0-15.19-18.13,33.89,33.89,0,0,0-23.31-3,30.93,30.93,0,0,0-18.75,12.15c-4.56,6.46-6.35,14.64-5.23,23.76-13.52,3.07-19.17,14.1-18.73,24M136,151.56a5.68,5.68,0,1,1-5.68,5.68,5.68,5.68,0,0,1,5.68-5.68m23-17a5.68,5.68,0,1,1-5.68,5.68,5.69,5.69,0,0,1,5.68-5.68m19.18,32.86a5.68,5.68,0,1,1-5.68-5.68,5.69,5.69,0,0,1,5.68,5.68m16.11-23.14a5.68,5.68,0,1,1-5.67,5.68,5.68,5.68,0,0,1,5.67-5.68M136,166.87a9.64,9.64,0,0,0,9.63-9.63,9.53,9.53,0,0,0-.79-3.82l7.6-6.14a9.61,9.61,0,0,0,8.11,2.5l5.17,10.87A9.63,9.63,0,1,0,181.07,163l7.15-5.55a9.61,9.61,0,1,0-2.47-3.09l-7.2,5.6a9.59,9.59,0,0,0-9.47-1.46l-4.81-10.11A9.63,9.63,0,1,0,150.19,144l-7.61,6.15A9.63,9.63,0,1,0,136,166.87"
        transform="translate(-73.03 -76.79)"
      />
    </svg>
  );
};
